import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { STAGE_ORDER_FULL, STAGE_LABELS } from './constants';

const API_URL = import.meta.env.VITE_API_URL;

function Pipeline({ onOpenCandidate }) {
  const [applications, setApplications] = useState([]);
  const [roleFilter, setRoleFilter] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/recruitment/applications`, { params: { status: 'in_progress' } });
      setApplications(res.data.applications);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const roles = [...new Set(applications.map((a) => a.roleLabel))];
  const visible = roleFilter ? applications.filter((a) => a.roleLabel === roleFilter) : applications;

  if (loading) return <p className="text-gray-400 text-sm">Loading pipeline...</p>;

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <select
          value={roleFilter}
          onChange={(e) => setRoleFilter(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm"
        >
          <option value="">All roles</option>
          {roles.map((r) => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4">
        {STAGE_ORDER_FULL.map((stage) => {
          const cards = visible.filter((a) => a.currentStage === stage);
          return (
            <div key={stage} className="flex-shrink-0 w-64 bg-gray-50 border border-gray-200 rounded-xl p-3">
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wide">{STAGE_LABELS[stage]}</h3>
                <span className="text-xs bg-gray-200 text-gray-600 rounded-full px-2 py-0.5">{cards.length}</span>
              </div>
              <div className="space-y-2 min-h-[40px]">
                {cards.map((app) => (
                  <button
                    key={app.id}
                    onClick={() => onOpenCandidate(app.id)}
                    className="w-full text-left bg-white border border-gray-200 rounded-lg p-3 hover:border-emerald-400 hover:shadow-sm transition"
                  >
                    <p className="text-sm font-medium text-gray-800">{app.candidateName}</p>
                    <p className="text-xs text-gray-500 mt-0.5">{app.roleLabel}</p>
                    <p className="text-xs text-gray-400 mt-1">Updated {new Date(app.updatedAt).toLocaleDateString()}</p>
                  </button>
                ))}
                {cards.length === 0 && <p className="text-xs text-gray-300 text-center py-4">Empty</p>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Pipeline;
